<script lang="ts">
  /* Where the «confirm your new password» e-mail lands. The change was asked
     for in the profile editor (current password + new one twice); it applies
     only here. A button, not an automatic call on load: mail scanners that
     open links must not be able to finish the change on their own. */
  import { _ } from "svelte-i18n";
  import { api } from "$lib/api";

  let { params }: { params: { token: string } } = $props();

  let loading = $state(false);
  let error = $state<string | null>(null);
  let success = $state(false);

  async function confirmChange() {
    loading = true;
    error = null;
    try {
      await api.post("/auth/password-change/confirm", { token: params.token });
      success = true;
    } catch {
      error = $_("auth.confirmPassword.invalid");
    } finally {
      loading = false;
    }
  }
</script>

<div class="auth-page">
  <div class="auth-card">
    <div class="brand">
      <img src="/logo.svg" alt="Order Evolution" class="logo" />
      <h2>{$_("auth.confirmPassword.title")}</h2>
    </div>

    {#if success}
      <div class="success-message">
        <span class="material-icons">check_circle</span>
        <p>{$_("account.password.saved")}</p>
      </div>
      <p class="bottom"><a href="#/">{$_("auth.confirmPassword.continue")}</a></p>
    {:else}
      <div class="auth-form">
        <p class="subtitle">{$_("auth.confirmPassword.subtitle")}</p>
        {#if error}
          <div class="error-alert" role="alert">{error}</div>
        {/if}
        <button type="button" class="btn btn--primary btn--lg" disabled={loading} onclick={confirmChange}>
          {loading ? `${$_("common.processing")}...` : $_("auth.confirmPassword.submit")}
        </button>
        <p class="bottom"><a href="#/">{$_("auth.confirmPassword.continue")}</a></p>
      </div>
    {/if}
  </div>
</div>

<style>
  .auth-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-bg);
    padding: 20px;
  }
  .auth-card {
    width: 100%;
    max-width: 440px;
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.05);
  }
  .brand { text-align: center; margin-bottom: 24px; }
  .logo { height: 48px; margin-bottom: 16px; }
  .brand h2 { margin: 0; font-size: 24px; color: var(--color-surface-dark); }
  .subtitle { margin: 0; color: var(--color-text-muted); text-align: center; line-height: 1.5; }

  .auth-form { display: flex; flex-direction: column; gap: 20px; }

  .btn--lg { padding: 14px; font-size: 16px; font-weight: 600; border-radius: 6px; cursor: pointer; }
  .btn--primary { background: var(--color-primary); color: white; border: none; }
  .btn--primary:hover { opacity: 0.9; }
  .btn:disabled { opacity: 0.7; cursor: not-allowed; }

  .error-alert {
    padding: 12px;
    background: #fff5f5;
    border: 1px solid #ffc1c1;
    color: #e53935;
    border-radius: 6px;
    font-size: 14px;
    text-align: center;
  }

  .success-message { text-align: center; padding: 12px 0 20px; }
  .success-message .material-icons { font-size: 64px; color: #4caf50; margin-bottom: 16px; }
  .success-message p { margin: 8px 0; font-size: 18px; font-weight: 600; }

  .bottom { text-align: center; margin: 0; font-size: 13px; }
</style>
